var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import { Property } from './property';
import { useNotionContext } from '../context';
import { CollectionGroup } from './collection-group';
import { cs, getCollectionGroups, retrieveBlocks } from '../utils';
import { UseRetrieveBlocks } from '../hooks/useRetrieveBlocks';
import { format } from 'date-fns';
export var CollectionViewList = function (_a) {
    var _b, _c, _d, _e, _f;
    var collection = _a.collection, collectionView = _a.collectionView, collectionData = _a.collectionData;
    var isGroupedCollection = (_b = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _b === void 0 ? void 0 : _b.collection_group_by;
    var recordMap = useNotionContext().recordMap;
    var _g = UseRetrieveBlocks(), retrieveMissingCollections = _g.retrieveMissingCollections, retrieveGroupBlocks = _g.retrieveGroupBlocks, retrieveMissingBlocks = _g.retrieveMissingBlocks;
    var applyBlockFilter = useCallback(function (blockIds, filters) {
        var handFilter = function (blockId) {
            var _a, _b, _c, _d, _e;
            var block = (_a = recordMap.block[blockId]) === null || _a === void 0 ? void 0 : _a.value;
            var condition = true;
            for (var _i = 0, _f = filters || []; _i < _f.length; _i++) {
                var filter = _f[_i];
                var dFilter = filter === null || filter === void 0 ? void 0 : filter.filter;
                switch (dFilter.filter.operator) {
                    case 'checkbox_is': {
                        // console.log('checkbox_is')
                        var value_1 = (_c = (_b = block === null || block === void 0 ? void 0 : block.properties[dFilter.property]) === null || _b === void 0 ? void 0 : _b.flat()) === null || _c === void 0 ? void 0 : _c.flat()[0];
                        var f_value = (_e = (_d = dFilter === null || dFilter === void 0 ? void 0 : dFilter.filter) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.value;
                        if (f_value) {
                            condition = value_1
                                ? /yes/gi.test(value_1) || f_value == value_1
                                : false;
                        }
                        else {
                            condition = value_1
                                ? /No/gi.test(value_1) || f_value == value_1
                                : true;
                        }
                    }
                }
            }
            return condition;
        };
        return blockIds.filter(function (blockId) { return handFilter(blockId); });
    }, [recordMap]);
    var cFilters = (_c = collectionView.format) === null || _c === void 0 ? void 0 : _c.property_filters;
    var value;
    if (isGroupedCollection) {
        var collectionGroups = getCollectionGroups(collection, collectionView, collectionData);
        var allBlocks = retrieveGroupBlocks(collectionGroups, collectionData, collection).blockIds.flat();
        allBlocks.length > 0 &&
            retrieveMissingBlocks(allBlocks.map(function (id) { return ({ id: id, table: 'block' }); }));
        var missingGroups_2 = [];
        var el = collectionGroups === null || collectionGroups === void 0 ? void 0 : collectionGroups.map(function (group, key) {
            var _a;
            if (!group.collectionGroup && !/uncategorized/.test(group.prop))
                missingGroups_2.push(group);
            var schema = group === null || group === void 0 ? void 0 : group.schema;
            value = group === null || group === void 0 ? void 0 : group.value;
            var blockIds = group.blockIds ||
                retrieveBlocks(collection, collectionView, collectionData, recordMap) ||
                [];
            var property = (_a = Object.entries(collection.schema).find(function (entry) {
                return entry[1].name == (schema === null || schema === void 0 ? void 0 : schema.name);
            })) === null || _a === void 0 ? void 0 : _a[0];
            if (property && filters_1) {
                blockIds = blockIds.filter(function (blockId) {
                    var _a, _b, _c, _d;
                    var block = (_a = recordMap.block[blockId]) === null || _a === void 0 ? void 0 : _a.value;
                    var bValue = (_d = (_c = (_b = block === null || block === void 0 ? void 0 : block.properties) === null || _b === void 0 ? void 0 : _b[property]) === null || _c === void 0 ? void 0 : _c.flat()) === null || _d === void 0 ? void 0 : _d.flat()[0];
                    return bValue === null || bValue === void 0 ? void 0 : bValue.split(',').includes(value);
                });
                group.blockIds = blockIds;
            }
            group.property = collectionView.format.collection_group_by.property;
            group.blockIds = applyBlockFilter(blockIds, cFilters);
            return (React.createElement(CollectionGroup, __assign({ key: key }, group, { collectionViewComponent: List })));
        });
        var gBP_1 = (_d = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _d === void 0 ? void 0 : _d.collection_group_by.property;
        var filters_1 = (_f = (((((_e = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _e === void 0 ? void 0 : _e.property_filters) || []).length > 0 &&
            collectionView.format.property_filters.find(function (f) { return f.filter.property == gBP_1; })) ||
            null)) === null || _f === void 0 ? void 0 : _f.filter;
        if (filters_1 && missingGroups_2.length > 0) {
            var reducers = {};
            for (var _i = 0, missingGroups_1 = missingGroups_2; _i < missingGroups_1.length; _i++) {
                var group = missingGroups_1[_i];
                var mFilters = __assign(__assign({}, filters_1), { filter: __assign(__assign({}, filters_1.filter), {
                        value: __assign(__assign({}, filters_1.filter.value), { value: group.value })
                    }) });
                reducers[group.prop] = {
                    type: 'results',
                    limit: 50,
                    filter: {
                        operator: 'and',
                        filters: [mFilters]
                    }
                };
            }
            retrieveMissingCollections(collection.id, collectionView.id, reducers);
        }
        return el;
    }
    var blockIds = retrieveBlocks(collection, collectionView, collectionData, recordMap);
    if (!blockIds)
        return null;
    blockIds = applyBlockFilter(blockIds, cFilters);
    return (React.createElement(List, { blockIds: blockIds, collection: collection, collectionView: collectionView, value: value }));
    // return (
    //   <List
    //     blockIds={collectionData['collection_group_results'].blockIds}
    //     collection={collection}
    //     collectionView={collectionView}
    //   />
    // )
};
function List(_a) {
    var _b, _c, _d, _e;
    var blockIds = _a.blockIds, collection = _a.collection, collectionView = _a.collectionView, value = _a.value;
    var _f = useNotionContext(), recordMap = _f.recordMap, components = _f.components, mapPageUrl = _f.mapPageUrl;
    // console.log({collection, collectionView, value})
    var groupBy = (_c = (_b = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _b === void 0 ? void 0 : _b.collection_group_by) === null || _c === void 0 ? void 0 : _c.groupBy;
    if (groupBy === 'month') {
        var property_1 = (_e = (_d = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _d === void 0 ? void 0 : _d.collection_group_by) === null || _e === void 0 ? void 0 : _e.property;
        return (React.createElement("div", { className: 'notion-list-collection' },
            React.createElement("div", { className: 'notion-list-view' },
                React.createElement("div", { className: 'notion-list-body' }, blockIds === null || blockIds === void 0 ? void 0 : blockIds.map(function (blockId) {
                    var _a, _b, _c, _d, _e;
                    var block = (_a = recordMap.block[blockId]) === null || _a === void 0 ? void 0 : _a.value;
                    if (!block)
                        return null;
                    var dateProp = (_b = block.properties) === null || _b === void 0 ? void 0 : _b[property_1].flat().flat()[1][1].start_date;
                    var formatDate = format(new Date(dateProp), 'MMM yyy');
                    if (formatDate !== value)
                        return null;
                    var titleSchema = collection.schema.title;
                    var titleData = (_c = block === null || block === void 0 ? void 0 : block.properties) === null || _c === void 0 ? void 0 : _c.title;
                    return (React.createElement("div", { key: blockId, className: 'notion-list-item' },
                        React.createElement(components.pageLink, { className: 'notion-page-link', href: mapPageUrl(block.id) },
                            React.createElement("div", { className: 'notion-list-item-title' },
                                React.createElement(Property, { schema: titleSchema, data: titleData, block: block, collection: collection, type: groupBy }))),
                        React.createElement("div", { className: 'notion-list-item-body' }, (_e = (_d = collectionView.format) === null || _d === void 0 ? void 0 : _d.list_properties) === null || _e === void 0 ? void 0 : _e.filter(function (p) { return p.visible; }).map(function (p) {
                            var _a;
                            var schema = collection.schema[p.property];
                            var data = block && ((_a = block.properties) === null || _a === void 0 ? void 0 : _a[p.property]);
                            if (!schema) {
                                return null;
                            }
                            if (data == titleData)
                                return null;
                            return (React.createElement("div", { className: cs('notion-list-item-property', 'notion-list-item-property-' + schema.type), key: p.property },
                                React.createElement(Property, { schema: schema, data: data, block: block, collection: collection })));
                        }))));
                })))));
    }
    return (React.createElement("div", { className: 'notion-list-collection' },
        React.createElement("div", { className: 'notion-list-view' },
            React.createElement("div", { className: 'notion-list-body' }, blockIds === null || blockIds === void 0 ? void 0 : blockIds.map(function (blockId) {
                var _a, _b, _c, _d;
                var block = (_a = recordMap.block[blockId]) === null || _a === void 0 ? void 0 : _a.value;
                if (!block)
                    return null;
                var titleSchema = collection.schema.title;
                var titleData = (_b = block === null || block === void 0 ? void 0 : block.properties) === null || _b === void 0 ? void 0 : _b.title;
                return (React.createElement("div", { key: blockId, className: 'notion-list-item' },
                    React.createElement(components.pageLink, { className: 'notion-page-link', href: mapPageUrl(block.id) },
                        React.createElement("div", { className: 'notion-list-item-title' },
                            React.createElement(Property, { schema: titleSchema, data: titleData, block: block, collection: collection }))),
                    React.createElement("div", { className: 'notion-list-item-body' }, (_d = (_c = collectionView.format) === null || _c === void 0 ? void 0 : _c.list_properties) === null || _d === void 0 ? void 0 : _d.filter(function (p) { return p.visible; }).map(function (p) {
                        var _a;
                        var schema = collection.schema[p.property];
                        var data = block && ((_a = block.properties) === null || _a === void 0 ? void 0 : _a[p.property]);
                        if (!schema) {
                            return null;
                        }
                        if (data == titleData)
                            return null;
                        return (React.createElement("div", { className: cs('notion-list-item-property', 'notion-list-item-property-' + schema.type), key: p.property },
                            React.createElement(Property, { schema: schema, data: data, block: block, collection: collection })));
                    }))));
            })))));
}
//# sourceMappingURL=collection-view-list.js.map